import { __decorate } from "tslib";
import { BOT_STATISTICS } from '@/helpers/constants/bot_statistics';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import BaseAnalyticsBanner from '@/components/v2/BaseAnalyticsBanner.vue';
import BaseAnalyticsBannerContent from '@/components/v2/BaseAnalyticsBannerContent.vue';
import ThisMonthTotalOrdersQuery from '@/plugins/graphql/queries/v2/ecommerce/current-month-orders.gql';
import RouteParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
let ThisMonthTotalOrders = class ThisMonthTotalOrders extends mixins(RouteParamsAppMixin) {
    constructor() {
        super(...arguments);
        this.totalOrdersCount = BOT_STATISTICS;
        this.section = 'Total Orders This Month';
        this.subTitle = 'Average Daily Orders';
    }
};
ThisMonthTotalOrders = __decorate([
    Component({
        components: {
            BaseAnalyticsBanner,
            BaseAnalyticsBannerContent,
        },
        apollo: {
            totalOrdersCount: {
                query: ThisMonthTotalOrdersQuery,
                variables() {
                    return {
                        appUuid: this.appUUID,
                        withinDay: false,
                    };
                },
                fetchPolicy: 'cache-and-network',
            },
        },
    })
], ThisMonthTotalOrders);
export default ThisMonthTotalOrders;
